import { render, staticRenderFns } from "./LayoutStage.vue?vue&type=template&id=1a8835f6&scoped=true&"
import script from "./LayoutStage.vue?vue&type=script&lang=js&"
export * from "./LayoutStage.vue?vue&type=script&lang=js&"
import style0 from "./LayoutStage.vue?vue&type=style&index=0&id=1a8835f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8835f6",
  null
  
)

export default component.exports